import Drawflow from "drawflow";
import { useEffect, useRef, useState } from "react";
import "../themes/globalStyles.css";

import { IWorkflow } from "@/interfaces/workflow.interface";

interface UseDrawflowInitializerProps {
  workflow: IWorkflow | null;
}

const useDrawflowInitializer = ({ workflow }: UseDrawflowInitializerProps) => {
  const drawflowRef = useRef<HTMLDivElement>(null);
  const editorRef = useRef<Drawflow | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!drawflowRef.current || editorRef.current || !workflow) return;

    const editor = new Drawflow(drawflowRef.current);
    editorRef.current = editor;
    editor.start();

    setIsInitialized(true);
  }, [workflow]);

  return { drawflowRef, editorRef, isInitialized };
};

export default useDrawflowInitializer;
